<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card class="submission-card" rounded="lg">
          <v-card-title class="d-flex align-center submission-header pa-5">
            <div>
              <div class="text-subtitle-2 text-medium-emphasis">
                Requirement Submission
              </div>
              <div class="text-h6 font-weight-bold">View Submission</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              density="comfortable"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="submission-body pa-5" style="max-height: 900px">
            <v-container class="pa-0">
              <v-row>
                <v-col cols="12" sm="6">
                  <div class="info-label">
                    <v-icon size="16" class="mr-1" color="grey-darken-1"
                      >mdi-account-outline</v-icon
                    >
                    Student Name
                  </div>
                  <div class="info-value">{{ name }}</div>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="info-label">
                    <v-icon size="16" class="mr-1" color="grey-darken-1"
                      >mdi-calendar-outline</v-icon
                    >
                    Date Submitted
                  </div>
                  <div class="info-value">
                    {{ formatDate(date_submitted) }}
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="info-label">
                    <v-icon size="16" class="mr-1" color="grey-darken-1"
                      >mdi-file-document-outline</v-icon
                    >
                    Requirement Submitted
                  </div>
                  <v-chip
                    size="small"
                    color="green-lighten-5"
                    class="requirement-chip mt-1"
                    label
                  >
                    <span class="text-green-darken-2 font-weight-medium">{{
                      requirement_name
                    }}</span>
                  </v-chip>
                </v-col>

                <v-col cols="12">
                  <div class="pdf-frame elevation-0">
                    <div
                      v-if="!url"
                      class="pdf-loading d-flex flex-column align-center justify-center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="green"
                        size="32"
                      ></v-progress-circular>
                      <div class="text-caption text-medium-emphasis mt-3">
                        Loading document...
                      </div>
                    </div>
                    <VuePdfEmbed v-else :source="url" />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4" v-if="status == 1">
            <v-spacer></v-spacer>
            <v-btn
              color="red-darken-1"
              variant="outlined"
              rounded="lg"
              class="text-none px-4"
              @click="pending()"
              :loading="btnLoading"
              :disabled="btnLoading"
            >
              <v-icon start>mdi-close-circle-outline</v-icon>
              Pending
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text text-none px-4"
              rounded="lg"
              density="comfortable"
              variant="flat"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="approve()"
            >
              <v-icon start>mdi-check-circle</v-icon>
              Approve
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <RemarksDialog
      :data="showRemarksDialog"
      v-on:save="saveRemarks"
      v-on:close="closeRemarks"
    />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import VuePdfEmbed from "vue-pdf-embed";
import RemarksDialog from "../Forms/RemarksDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  components: {
    VuePdfEmbed,
    RemarksDialog,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      status: null,
      name: null,
      requirement_name: null,
      requirement_submission_id: null,
      date_submitted: null,
      file: null,
      filename: null,
      remarks: null,
      btnLoading: false,
      deletedFile: null,
      url: null,
      showRemarksDialog: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        console.log(data);
        this.requirement_submission_id = data.id;
        this.requirement_name = data.student_requirement;
        this.status = data.submitted_status;
        this.name = data.name;
        this.url = null;
        this.date_submitted = data.createdAt;
        this.getFile(data.filename);
        // this.$refs.StudentReqForm.resetValidation();
        // this.$refs.StudentReqForm.reset();
        // this.name = data.requirement_name;
        // this.file = null;
        // this.remarks = data.remarks;
        // this.requirement_submission_id = data.requirement_submission_id;
        // this.requirement_id = data.requirement_id;
        // this.filename = data.file;
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      //   this.getPrograms();
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    approve() {
      this.btnLoading = true;
      this.proceed(2, null);
    },
    pending() {
      this.showRemarksDialog = true;
      console.log("Pending");
    },

    saveRemarks(remarks) {
      this.showRemarksDialog = false;
      this.proceed(3, remarks);
    },
    closeRemarks() {
      this.showRemarksDialog = false;
    },

    proceed(approval, remarks) {
      this.btnLoading = true;
      let data = {
        id: this.data.id,
        remarks: remarks,
      };
      let url;
      let type;
      if (approval == 2) {
        url = "/student-requirement-submission/approve/" + this.data.id;
        type = "PATCH";
      }
      if (approval == 3) {
        url = "/student-requirement-submission/saveDisapproval";
        type = "POST";
      }

      this.axiosCall(url, type, data).then((res) => {
        if (res.data.status == 200) {
          this.$emit("approval", approval);

          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.btnLoading = false;
          this.closeD();
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },

    // async save() {
    //   let formValid = await this.$refs.StudentReqForm.validate();

    //   if (formValid.valid) {
    //     this.btnLoading = true;
    //     let data = {
    //       requirement_id: this.requirement_id,
    //     };
    //     let fd = new FormData();
    //     fd.append("data", JSON.stringify(data));
    //     fd.append("file", this.file);
    //     this.axiosCall(
    //       "/student-requirement-submission/submitRequirement",
    //       "POST",
    //       fd,
    //     ).then((res) => {
    //       if (res.data.status == 201) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //         this.btnLoading = false;
    //         this.closeD();
    //       } else {
    //         this.btnLoading = false;
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //       }
    //     });
    //   }
    // },

    // async update() {
    //   let formValid = await this.$refs.StudentReqForm.validate();

    //   if (formValid.valid) {
    //     this.btnLoading = true;
    //     let data = {
    //       requirement_submission_id: this.requirement_submission_id,
    //       requirement_id: this.requirement_id,
    //       prevFile: this.filename,
    //     };
    //     let fd = new FormData();
    //     fd.append("data", JSON.stringify(data));
    //     fd.append("file", this.file);
    //     this.axiosCall(
    //       "/student-requirement-submission/updateSubmission",
    //       "PATCH",
    //       fd,
    //     ).then((res) => {
    //       if (res.data.status == 200) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //         this.btnLoading = false;
    //         this.closeD();
    //       } else {
    //         this.btnLoading = false;
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //       }
    //     });
    //   }
    // },
    closeD() {
      //   URL.revokeObjectURL();
      eventBus.emit("closeViewSubmissionDialog", true);

      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    getFile(file) {
      //   let iframe = document.getElementById("iframe");
      let url =
        process.env.VUE_APP_SERVER +
        "/student-requirement-submission/get-file/" +
        file;

      let token = localStorage.getItem("token");
      //   const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          this.url = _url;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}

.submission-card {
  overflow: hidden;
}

.submission-header {
  background-color: #fafafa;
}

.submission-body {
  background-color: #ffffff;
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #757575;
  margin-bottom: 4px;
}

.info-value {
  font-size: 0.95rem;
  font-weight: 500;
  color: #212121;
}

.requirement-chip {
  border-radius: 6px;
}

.pdf-frame {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  background-color: #f5f5f5;
  min-height: 400px;
}

.pdf-loading {
  min-height: 400px;
}
</style>
